"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var types_1 = require("../../app/util/types");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        loginField: {
            borderRadius: '3px',
        },
        loginInputText: {
            color: theme.palette.grey[800],
        },
        buttonRow: {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        signInButton: {
            width: '140px',
            minWidth: '120px',
            marginRight: theme.spacing(2),
        },
    });
});
// Form object to request for user's email or OTP
var LoginForm = function (_a) {
    var id = _a.id, placeholder = _a.placeholder, buttonMessage = _a.buttonMessage, variant = _a.variant, autoComplete = _a.autoComplete, onChange = _a.onChange, textError = _a.textError, textErrorMessage = _a.textErrorMessage, onSubmit = _a.onSubmit, children = _a.children, value = _a.value;
    var classes = useStyles();
    var variantMap = types_1.loginFormVariants.map[variant];
    return (react_1.default.createElement("form", { onSubmit: onSubmit, autoComplete: autoComplete },
        react_1.default.createElement(core_1.TextField, { autoFocus: true, required: true, fullWidth: true, variant: "outlined", placeholder: placeholder, onChange: function (event) { return onChange(event.target.value); }, InputProps: {
                classes: {
                    input: classes.loginInputText,
                },
            }, className: classes.loginField, margin: "normal", id: id, name: id, disabled: !variantMap.inputEnabled, error: textError(), helperText: textErrorMessage(), value: value }),
        react_1.default.createElement("section", { className: classes.buttonRow },
            react_1.default.createElement(core_1.Button, { className: classes.signInButton, type: "submit", variant: "contained", color: "primary", disabled: !variantMap.submitEnabled || !!textError(), size: "large" }, buttonMessage),
            children)));
};
exports.default = LoginForm;
